module.exports = __webpack_public_path__ + "img/square_opaque.7a4d1b87.svg";